import { render, staticRenderFns } from "./NTApplyPopup.vue?vue&type=template&id=025f2fd1&scoped=true"
import script from "./NTApplyPopup.vue?vue&type=script&lang=js"
export * from "./NTApplyPopup.vue?vue&type=script&lang=js"
import style0 from "./NTApplyPopup.vue?vue&type=style&index=0&id=025f2fd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f2fd1",
  null
  
)

export default component.exports